'use client';

import type { IconProps } from '@iconify/react';
import { Icon } from '@iconify/react';
import NoSsr from '@mui/material/NoSsr';
import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { mergeClasses } from 'minimal-shared/utils';
import { forwardRef } from 'react';

import { iconifyClasses } from './classes';

const IconRoot = styled(Icon)``;

const IconFallback = styled('span')``;

export type IconifyProps = React.ComponentProps<typeof IconRoot> & IconProps;

export const Iconify = forwardRef<SVGSVGElement, IconifyProps>((props, ref) => {
  const { className, width = 20, sx, ...other } = props;

  const baseStyles: SxProps<Theme> = {
    width: `${width}px !important`,
    height: `${width}px !important`,
    flexShrink: 0,
    display: 'inline-flex',
  };

  const renderFallback = () => (
    <IconFallback
      className={mergeClasses([iconifyClasses.root, className])}
      sx={[baseStyles, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );

  return (
    <NoSsr fallback={renderFallback()}>
      <IconRoot
        ssr
        ref={ref}
        className={mergeClasses([iconifyClasses.root, className])}
        sx={[baseStyles, ...(Array.isArray(sx) ? sx : [sx])]}
        {...other}
      />
    </NoSsr>
  );
});
